/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DrillingRigShortInfo,
  DrillingRigStatus,
  DrillingRigToWellLink,
  DrillingRigToWellLinkCreateDto,
  DrillingRigV2,
  DrillingRigV2Request,
  ErrorResponse,
  LinkWithDrillingRig,
  LinkWithWell,
  ValidationErrorResponse,
} from '../models/index';
import {
    DrillingRigShortInfoFromJSON,
    DrillingRigShortInfoToJSON,
    DrillingRigStatusFromJSON,
    DrillingRigStatusToJSON,
    DrillingRigToWellLinkFromJSON,
    DrillingRigToWellLinkToJSON,
    DrillingRigToWellLinkCreateDtoFromJSON,
    DrillingRigToWellLinkCreateDtoToJSON,
    DrillingRigV2FromJSON,
    DrillingRigV2ToJSON,
    DrillingRigV2RequestFromJSON,
    DrillingRigV2RequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LinkWithDrillingRigFromJSON,
    LinkWithDrillingRigToJSON,
    LinkWithWellFromJSON,
    LinkWithWellToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';

export interface CreateRequest {
    drillingRigV2Request: DrillingRigV2Request;
}

export interface Delete1Request {
    id: number;
}

export interface EditLinkRequest {
    linkId: string;
    drillingRigToWellLinkCreateDto: DrillingRigToWellLinkCreateDto;
}

export interface FindAllByFilterRequest {
    purpose?: string;
    drillingCompany?: string;
    model?: string;
}

export interface FindAllByWellIdRequest {
    wellId: number;
}

export interface FindAllShortInfoRequest {
    purpose?: string;
}

export interface FindCurrentLinkRequest {
    drillingRigId: number;
}

export interface GetByIdRequest {
    id: number;
}

export interface GetLinkRequest {
    linkId: string;
}

export interface GetStatusByIdRequest {
    id: number;
}

export interface LinkWellRequest {
    drillingRigToWellLinkCreateDto: DrillingRigToWellLinkCreateDto;
}

export interface RemoveLinkRequest {
    linkId: string;
}

export interface UpdateRequest {
    id: number;
    drillingRigV2Request: DrillingRigV2Request;
}

/**
 * 
 */
export class DrillingRigControllerApi extends runtime.BaseAPI {

    /**
     */
    async createRaw(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['drillingRigV2Request'] == null) {
            throw new runtime.RequiredError(
                'drillingRigV2Request',
                'Required parameter "drillingRigV2Request" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DrillingRigV2RequestToJSON(requestParameters['drillingRigV2Request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async create(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createRaw(requestParameters, initOverrides);
    }

    /**
     */
    async delete1Raw(requestParameters: Delete1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling delete1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async delete1(requestParameters: Delete1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.delete1Raw(requestParameters, initOverrides);
    }

    /**
     */
    async editLinkRaw(requestParameters: EditLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DrillingRigToWellLink>> {
        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling editLink().'
            );
        }

        if (requestParameters['drillingRigToWellLinkCreateDto'] == null) {
            throw new runtime.RequiredError(
                'drillingRigToWellLinkCreateDto',
                'Required parameter "drillingRigToWellLinkCreateDto" was null or undefined when calling editLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/links/{linkId}`.replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters['linkId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DrillingRigToWellLinkCreateDtoToJSON(requestParameters['drillingRigToWellLinkCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrillingRigToWellLinkFromJSON(jsonValue));
    }

    /**
     */
    async editLink(requestParameters: EditLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DrillingRigToWellLink> {
        const response = await this.editLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findAllByFilterRaw(requestParameters: FindAllByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DrillingRigV2>>> {
        const queryParameters: any = {};

        if (requestParameters['purpose'] != null) {
            queryParameters['purpose'] = requestParameters['purpose'];
        }

        if (requestParameters['drillingCompany'] != null) {
            queryParameters['drillingCompany'] = requestParameters['drillingCompany'];
        }

        if (requestParameters['model'] != null) {
            queryParameters['model'] = requestParameters['model'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DrillingRigV2FromJSON));
    }

    /**
     */
    async findAllByFilter(requestParameters: FindAllByFilterRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DrillingRigV2>> {
        const response = await this.findAllByFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findAllByWellIdRaw(requestParameters: FindAllByWellIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LinkWithDrillingRig>>> {
        if (requestParameters['wellId'] == null) {
            throw new runtime.RequiredError(
                'wellId',
                'Required parameter "wellId" was null or undefined when calling findAllByWellId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['wellId'] != null) {
            queryParameters['wellId'] = requestParameters['wellId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/links/find-by-well`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LinkWithDrillingRigFromJSON));
    }

    /**
     */
    async findAllByWellId(requestParameters: FindAllByWellIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LinkWithDrillingRig>> {
        const response = await this.findAllByWellIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findAllShortInfoRaw(requestParameters: FindAllShortInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DrillingRigShortInfo>>> {
        const queryParameters: any = {};

        if (requestParameters['purpose'] != null) {
            queryParameters['purpose'] = requestParameters['purpose'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/short-operation-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DrillingRigShortInfoFromJSON));
    }

    /**
     */
    async findAllShortInfo(requestParameters: FindAllShortInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DrillingRigShortInfo>> {
        const response = await this.findAllShortInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findCurrentLinkRaw(requestParameters: FindCurrentLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkWithWell>> {
        if (requestParameters['drillingRigId'] == null) {
            throw new runtime.RequiredError(
                'drillingRigId',
                'Required parameter "drillingRigId" was null or undefined when calling findCurrentLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/{drillingRigId}/links/current`.replace(`{${"drillingRigId"}}`, encodeURIComponent(String(requestParameters['drillingRigId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkWithWellFromJSON(jsonValue));
    }

    /**
     */
    async findCurrentLink(requestParameters: FindCurrentLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkWithWell> {
        const response = await this.findCurrentLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getByIdRaw(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DrillingRigV2>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrillingRigV2FromJSON(jsonValue));
    }

    /**
     */
    async getById(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DrillingRigV2> {
        const response = await this.getByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLinkRaw(requestParameters: GetLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DrillingRigToWellLink>> {
        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling getLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/links/{linkId}`.replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters['linkId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrillingRigToWellLinkFromJSON(jsonValue));
    }

    /**
     */
    async getLink(requestParameters: GetLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DrillingRigToWellLink> {
        const response = await this.getLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStatusByIdRaw(requestParameters: GetStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DrillingRigStatus>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getStatusById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrillingRigStatusFromJSON(jsonValue));
    }

    /**
     */
    async getStatusById(requestParameters: GetStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DrillingRigStatus> {
        const response = await this.getStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async linkWellRaw(requestParameters: LinkWellRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DrillingRigToWellLink>> {
        if (requestParameters['drillingRigToWellLinkCreateDto'] == null) {
            throw new runtime.RequiredError(
                'drillingRigToWellLinkCreateDto',
                'Required parameter "drillingRigToWellLinkCreateDto" was null or undefined when calling linkWell().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/links`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DrillingRigToWellLinkCreateDtoToJSON(requestParameters['drillingRigToWellLinkCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrillingRigToWellLinkFromJSON(jsonValue));
    }

    /**
     */
    async linkWell(requestParameters: LinkWellRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DrillingRigToWellLink> {
        const response = await this.linkWellRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeLinkRaw(requestParameters: RemoveLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DrillingRigToWellLink>> {
        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling removeLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/links/{linkId}`.replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters['linkId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrillingRigToWellLinkFromJSON(jsonValue));
    }

    /**
     */
    async removeLink(requestParameters: RemoveLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DrillingRigToWellLink> {
        const response = await this.removeLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling update().'
            );
        }

        if (requestParameters['drillingRigV2Request'] == null) {
            throw new runtime.RequiredError(
                'drillingRigV2Request',
                'Required parameter "drillingRigV2Request" was null or undefined when calling update().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/drilling-rig/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DrillingRigV2RequestToJSON(requestParameters['drillingRigV2Request']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async update(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRaw(requestParameters, initOverrides);
    }

}
